/* eslint-disable import/no-named-as-default */
import React from "react";
import PropTypes from "prop-types";
import BrandLogo from "./BrandLogo";
import Actions from "./Actions";
import HeaderWrapper from "./styles/header-styles";
import userType from "./types/userType";
import menuItemType from "./types/menuItemType";

const NotificationHeader = ({ rootPageUrl, user, ...props }) => (
  <HeaderWrapper id="navbar">
    <BrandLogo rootPageUrl={rootPageUrl} user={user} />
    <Actions user={user} {...props} />
  </HeaderWrapper>
);

NotificationHeader.propTypes = {
  rootPageUrl: PropTypes.string.isRequired,
  markAllNotificationsReadUrl: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(menuItemType).isRequired,
  messagesUrl: PropTypes.string.isRequired,
  notificationsUrl: PropTypes.string.isRequired,
  unreadMessages: PropTypes.number.isRequired,
  unreadNotifications: PropTypes.number.isRequired,
  user: userType.isRequired,
};

export default NotificationHeader;
